import { Utils } from 'mw-style-react';

export const GET_LAYERS = Utils.createRequestTypes('GET_LAYERS');
export const GET_LAYER_INFO = Utils.createRequestTypes('GET_LAYER_INFO');
export const CREATE_LAYER = Utils.createRequestTypes('CREATE_LAYER');
export const UPDATE_LAYER = Utils.createRequestTypes('UPDATE_LAYER');
export const REMOVE_LAYER = Utils.createRequestTypes('REMOVE_LAYER');
export const GET_LAYER = Utils.createRequestTypes('GET_LAYER');
export const SEARCH_LAYERS = Utils.createRequestTypes('SEARCH_LAYERS');
export const MANAGE_LAYER_ACTORS = Utils.createRequestTypes(
  'MANAGE_LAYER_ACTORS'
);
export const MAKE_AUTO_LAYER_PAGE = Utils.createRequestTypes(
  'MAKE_AUTO_LAYER_PAGE'
);
export const LAYER_ACCESS = Utils.createRequestTypes('LAYER_ACCESS');
export const PIN_LAYER = Utils.createRequestTypes('PIN_LAYER');
export const UNPIN_LAYER = Utils.createRequestTypes('UNPIN_LAYER');
export const CLOSE_LAYER = Utils.createRequestTypes('CLOSE_LAYER');
export const MOVE_LAYER = Utils.createRequestTypes('MOVE_LAYER');
export const SAVE_LAYER_POSITION = Utils.createRequestTypes(
  'SAVE_LAYER_POSITION'
);
export const SET_LAYER_SETTINGS =
  Utils.createRequestTypes('SET_LAYER_SETTINGS');
export const GET_LAYER_BALANCE = Utils.createRequestTypes('GET_LAYER_BALANCE');
export const STARRED_LAYER_ACTOR = Utils.createRequestTypes(
  'STARRED_LAYER_ACTOR'
);
export const GET_ACTOR_LAYER = Utils.createRequestTypes('GET_ACTOR_LAYER');
export const GET_TREE_LAYER = Utils.createRequestTypes('GET_TREE_LAYER');
export const SET_ACTIVE_LAYER = Utils.createRequestTypes('SET_ACTIVE_LAYER');
export const EDITABLE_NODE = Utils.createRequestTypes('EDITABLE_NODE');
export const COLLAPSE_ACTOR = Utils.createRequestTypes('COLLAPSE_ACTOR');
export const GET_VERTICAL_LAYER =
  Utils.createRequestTypes('GET_VERTICAL_LAYER');
export const GET_ALL_LAYERS = Utils.createRequestTypes('GET_ALL_LAYERS');
export const MANAGE_FOLDER_LAYERS = Utils.createRequestTypes(
  'MANAGE_FOLDER_LAYERS'
);
export const GET_LAYERS_COMMON_ACTORS = Utils.createRequestTypes(
  'GET_LAYERS_COMMON_ACTORS'
);

export const ADD_LAYERS_AREA = Utils.createRequestTypes('ADD_LAYERS_AREA');
export const CLEAR_NEW_LAYER_AREAS = Utils.createRequestTypes(
  'CLEAR_NEW_LAYER_AREAS'
);

export const GET_LAYER_LINKS = Utils.createRequestTypes('GET_LAYER_LINKS');
export const GET_ACTOR_LINKS = Utils.createRequestTypes('GET_ACTOR_LINKS');
export const ACTOR_DECOMPOSE = Utils.createRequestTypes('ACTOR_DECOMPOSE');
export const ACTORS_AGGREGATION =
  Utils.createRequestTypes('ACTORS_AGGREGATION');

export const SET_LAYERS_REQ_STATUS = 'SET_LAYERS_REQ_STATUS';
export const CLEAR_LAYERS = 'CLEAR_LAYERS';

export const SYSTEM_SPECIAL_LAYERS = [
  'graphRules',
  'accounts',
  'dashboards',
  'vertical',
];
